import { AxiosError } from "axios";

export enum ErrorKey {
  // Global errors
  INTERNAL_SERVER_ERROR = "INTERNAL_SERVER_ERROR",
  INVALID_PARAMS = "INVALID_PARAMS",
  UNAUTHORIZED = "UNAUTHORIZED",
  OBJECT_NOT_FOUND = "OBJECT_NOT_FOUND",
  INVALID_STORE = "INVALID_STORE",
  ERROR_GENERATING_CSV = "ERROR_GENERATING_CSV",
  RECAPTCHA_FAILED = "RECAPTCHA_FAILED",
  WRONG_FILE_FORMAT = "WRONG_FILE_FORMAT",
  STORE_OR_LANGUAGE_HEADER_NOT_DEFINED = "STORE_OR_LANGUAGE_HEADER_NOT_DEFINED",
  // Eshop Order Errors
  ORDER_ERROR_CHECKOUT_DETAILS = "ORDER_ERROR_CHECKOUT_DETAILS",
  ORDER_ERROR_INVALID_ORDER = "ORDER_ERROR_INVALID_ORDER",
  ORDER_ERROR_GOPAY = "ORDER_ERROR_GOPAY",
  ORDER_ERROR_ZASILKOVNA = "ORDER_ERROR_ZASILKOVNA",
  ORDER_ERROR_PPL = "ORDER_ERROR_PPL",
  ORDER_ERROR_INVALID_COUPON = "ORDER_ERROR_INVALID_COUPON",
  // Specific errors
  KONTAKT_ALREADY_EXISTS = "KONTAKT_ALREADY_EXISTS",
  
  SLUG_EMPTY = "SLUG_EMPTY",
  SLUG_VALUE_EMPTY = "SLUG_VALUE_EMPTY",
  SLUG_VALUE_INVALID = "SLUG_VALUE_INVALID",
  SLUG_ALREADY_EXISTS = "SLUG_ALREADY_EXISTS",
  PHONE_NUMBER_EMPTY = "PHONE_NUMBER_EMPTY",
  PHONE_NUMBER_INVALID = "PHONE_NUMBER_INVALID",
  FIRST_NAME_EMPTY = "FIRST_NAME_EMPTY",
  LAST_NAME_EMPTY = "LAST_NAME_EMPTY",
  ZIP_CODE_INVALID = "ZIP_CODE_INVALID",
  PASSWORD_EMPTY = "PASSWORD_EMPTY",
  PASSWORD_WEAK = "PASSWORD_WEAK",
  PASSWORD_REPEAT_EMPTY = "PASSWORD_REPEAT_EMPTY",
  PASSWORD_REPEAT_NOT_SAME = "PASSWORD_REPEAT_NOT_SAME",
  OLD_PASSWORD_INVALID = "OLD_PASSWORD_INVALID",
  OLD_PASSWORD_EMPTY = "OLD_PASSWORD_EMPTY",
  EMAIL_EMPTY = "EMAIL_EMPTY",
  EMAIL_INVALID = "EMAIL_INVALID",
  EMAIL_ALREADY_EXISTS = "EMAIL_ALREADY_EXISTS",
  EMAIL_MJML_INVALID = "EMAIL_MJML_INVALID",
  ITEMS_NOT_VALID = "ITEMS_NOT_VALID",
  ITEM_COUNT_NOT_VALID = "ITEM_COUNT_NOT_VALID",
  SUPPLEMENTARY_PRODUCT_NOT_VALID = "SUPPLEMENTARY_PRODUCT_NOT_VALID",
  SUPPLEMENTARY_PRODUCT_NOT_AVAILABLE = "SUPPLEMENTARY_PRODUCT_NOT_AVAILABLE",
  SUPPLEMENTARY_PRODUCT_ITEM_COUNT_NOT_VALID = "SUPPLEMENTARY_PRODUCT_ITEM_COUNT_NOT_VALID",
  SUPPLEMENTARY_PRODUCT_ITEM_IS_OUT_OF_STOCK = "SUPPLEMENTARY_PRODUCT_ITEM_IS_OUT_OF_STOCK",
  GIFT_PACKAGING_NOT_VALID = "GIFT_PACKAGING_NOT_VALID",
  GIFT_PACKAGING_NOT_AVAILABLE = "GIFT_PACKAGING_NOT_AVAILABLE",
  GIFT_PACKAGING_ITEM_COUNT_NOT_VALID = "GIFT_PACKAGING_ITEM_COUNT_NOT_VALID",
  CART_ITEMS_EXCEED_STOCK = "CART_ITEMS_EXCEED_STOCK",
  ITEMS_EMPTY = "ITEMS_EMPTY",
  ITEM_CANT_BE_ORDERED = "ITEM_CANT_BE_ORDERED",
  ITEM_IS_OUT_OF_STOCK = "ITEM_IS_OUT_OF_STOCK",
  ITEMS_NOT_IN_STOCK = "ITEMS_NOT_IN_STOCK",
  GIFT_PACKAGINGS_NOT_IN_STOCK = "GIFT_PACKAGINGS_NOT_IN_STOCK",
  SUPPLEMENTARY_ITEMS_NOT_IN_STOCK = "SUPPLEMENTARY_ITEMS_NOT_IN_STOCK",
  GIFT_PACKAGING_IS_OUT_OF_STOCK = "GIFT_PACKAGING_IS_OUT_OF_STOCK",
  SHIPPING_NOT_VALID = "SHIPPING_NOT_VALID",
  SHIPPING_EMPTY = "SHIPPING_EMPTY",
  PAYMENT_NOT_VALID = "PAYMENT_NOT_VALID",
  PAYMENT_EMPTY = "PAYMENT_EMPTY",
  PAYMENT_CANT_DELETE_REFERENCE = "PAYMENT_CANT_DELETE_REFERENCE",
  ADDRESS_EMPTY = "ADDRESS_EMPTY",
  CITY_EMPTY = "CITY_EMPTY",
  ZIP_CODE_EMPTY = "ZIP_CODE_EMPTY",
  CHECKOUT_NOT_VALID = "CHECKOUT_NOT_VALID",
  CHECKOUT_EMPTY = "CHECKOUT_EMPTY",
  CATEGORY_NAME_EMPTY = "CATEGORY_NAME_EMPTY",
  CURRENCY_TITLE_EMPTY = "CURRENCY_TITLE_EMPTY",
  CURRENCY_SYMBOL_EMPTY = "CURRENCY_SYMBOL_EMPTY",
  CURRENCY_SHORTCUT_EMPTY = "CURRENCY_SHORTCUT_EMPTY",
  CURRENCY_SHORTCUT_ALREADY_EXISTS = "CURRENCY_SHORTCUT_ALREADY_EXISTS",
  CURRENCY_CANT_DELETE_REFERENCE = "CURRENCY_CANT_DELETE_REFERENCE",
  STORE_CANT_DELETE_DEFAULT = "STORE_CANT_DELETE_DEFAULT",
  STORE_CANT_DELETE_REFERENCE = "STORE_CANT_DELETE_REFERENCE",
  STORE_KEY_EMPTY = "STORE_KEY_EMPTY",
  STORE_LOGO_EMPTY = "STORE_LOGO_EMPTY",
  STORE_KEY_ALREADY_EXISTS = "STORE_KEY_ALREADY_EXISTS",
  STORE_URL_EMPTY = "STORE_URL_EMPTY",
  STORE_TITLE_EMPTY = "STORE_TITLE_EMPTY",
  STORE_ESHOP_IDENTITY_EMPTY = "STORE_ESHOP_IDENTITY_EMPTY",
  STORE_EMAIL_SUBJECT_EMPTY = "STORE_EMAIL_SUBJECT_EMPTY",
  STORE_DEFAULT_EMAIL_EMPTY = "STORE_DEFAULT_EMAIL_EMPTY",
  STORE_DEFAULT_LANGUAGE_EMPTY = "STORE_DEFAULT_LANGUAGE_EMPTY",
  STORE_DEFAULT_CURRENCY_EMPTY = "STORE_DEFAULT_CURRENCY_EMPTY",
  STORE_SMTP_PASSWORD_EMPTY = "STORE_SMTP_PASSWORD_EMPTY",
  STORE_SMTP_LOGIN_EMPTY = "STORE_SMTP_LOGIN_EMPTY",
  STORE_SMTP_HOST_EMPTY = "STORE_SMTP_HOST_EMPTY",
  STORE_LANGUAGES_EMPTY = "STORE_LANGUAGES_EMPTY",
  STORE_LANGUAGES_NOT_VALID = "STORE_LANGUAGES_NOT_VALID",
  STORE_CURRENCIES_EMPTY = "STORE_CURRENCIES_EMPTY",
  STORE_CURRENCIES_NOT_VALID = "STORE_CURRENCIES_NOT_VALID",
  LANGUAGE_CANT_DELETE_DEFAULT = "LANGUAGE_CANT_DELETE_DEFAULT",
  LANGUAGE_CANT_DELETE_REFERENCE = "LANGUAGE_CANT_DELETE_REFERENCE",
  LANGUAGE_LOCALE_EMPTY = "LANGUAGE_LOCALE_EMPTY",
  LANGUAGE_LOCALE_ALREADY_EXISTS = "LANGUAGE_LOCALE_ALREADY_EXISTS",
  LANGUAGE_ISO_KEY_EMPTY = "LANGUAGE_ISO_KEY_EMPTY",
  LANGUAGE_TITLE_EMPTY = "LANGUAGE_TITLE_EMPTY",
  MANUFACTURER_NAME_EMPTY = "MANUFACTURER_NAME_EMPTY",
  PARAMETER_GROUP_TITLE_EMPTY = "PARAMETER_GROUP_TITLE_EMPTY",
  PARAMETER_GROUP_PARAMETERS_EMPTY = "PARAMETER_GROUP_PARAMETERS_EMPTY",
  PARAMETER_VALUE_EMPTY = "PARAMETER_VALUE_EMPTY",
  PARAMETER_VALUE_SPECIAL_PARAMETER_EMPTY = "PARAMETER_VALUE_SPECIAL_PARAMETERS_EMPTY",
  PARAMETER_VALUE_SPECIAL_PARAMETER_COLOR_EMPTY = "PARAMETER_VALUE_SPECIAL_PARAMETER_COLOR_EMPTY",
  PARAMETER_TITLE_EMPTY = "PARAMETER_TITLE_EMPTY",
  PAYMENT_PRICE_EMPTY = "PAYMENT_PRICE_EMPTY",
  PAYMENT_STORES_EMPTY = "PAYMENT_STORES_EMPTY",
  PAYMENT_TYPE_EMPTY = "PAYMENT_TYPE_EMPTY",
  PAYMENT_TYPE_ALREADY_EXISTS = "PAYMENT_TYPE_ALREADY_EXISTS",
  PRODUCT_PARAMETER_PARAMETER_MISSING = "PRODUCT_PARAMETER_PARAMETER_MISSING",
  PRODUCT_PARAMETER_VALUE_MISSING = "PRODUCT_PARAMETER_VALUE_MISSING",
  PRODUCT_PARAMETER_VALUE_INVALID = "PRODUCT_PARAMETER_VALUE_INVALID",
  PRODUCT_PARAMETER_INVALID_PARAMETERS = "PRODUCT_PARAMETER_INVALID_PARAMETERS",
  PRODUCT_TYPE_EMPTY = "PRODUCT_TYPE_EMPTY",
  PRODUCT_TYPE_INVALID = "PRODUCT_TYPE_INVALID",
  PRODUCT_SET_ATTRIBUTES_EMPTY = "PRODUCT_SET_ATTRIBUTES_EMPTY",
  PRODUCT_SET_ATTRIBUTES_INVALID = "PRODUCT_SET_ATTRIBUTES_PRODUCTS_INVALID",
  PRODUCT_ESHOP_ID_EXISTS = "PRODUCT_ESHOP_ID_EXISTS",
  PRODUCT_ESHOP_ID_EMPTY = "PRODUCT_ESHOP_ID_EMPTY",
  PRODUCT_NAME_EMPTY = "PRODUCT_NAME_EMPTY",
  PRODUCT_CANT_DELETE_REFERENCE = "PRODUCT_CANT_DELETE_REFERENCE",
  PRODUCT_BUY_PRICE_EMPTY = "PRODUCT_BUY_PRICE_EMPTY",
  PRODUCT_PRICE_VAT_EMPTY = "PRODUCT_PRICE_VAT_EMPTY",
  PRODUCT_PARAMETER_GROUPS = "PRODUCT_PARAMETER_GROUPS",
  PRODUCT_PARAMS = "PRODUCT_PARAMS",
  PRODUCT_IMPORT_DATA_INVALID = "PRODUCT_IMPORT_DATA_INVALID",
  SHIPPING_PRICE_EMPTY = "SHIPPING_PRICE_EMPTY",
  SHIPPING_STORES_EMPTY = "SHIPPING_STORES_EMPTY",
  SHIPPING_TYPE_EMPTY = "SHIPPING_TYPE_EMPTY",
  SHIPPING_TYPE_ALREADY_EXISTS = "SHIPPING_TYPE_ALREADY_EXISTS",
  SHIPPING_CANT_DELETE_REFERENCE = "SHIPPING_CANT_DELETE_REFERENCE",
  TASK_TITLE_EMPTY = "TASK_TITLE_EMPTY",
  USERNAME_EMPTY = "USERNAME_EMPTY",
  USERNAME_ALREADY_EXISTS = "USERNAME_ALREADY_EXISTS",
  COUPON_KEY_EMPTY = "COUPON_KEY_EMPTY",
  COUPON_KEY_ALREADY_EXISTS = "COUPON_KEY_ALREADY_EXISTS",
  COUPON_TYPE_EMPTY = "COUPON_TYPE_EMPTY",
  COUPON_VALUE_EMPTY = "COUPON_VALUE_EMPTY",
  COUPON_VALUE_INVALID = "COUPON_VALUE_INVALID",
  COUPON_VALUE_PERCENT_INVALID = "COUPON_VALUE_PERCENT_INVALID",
  ADMIN_INVALID_LOGIN = "ADMIN_INVALID_LOGIN",
  ADMIN_INVALID_AUTH = "ADMIN_INVALID_AUTH",
  ADMIN_USER_ALREADY_EXISTS = "ADMIN_USER_ALREADY_EXISTS",
  ADMIN_INVALID_ROLE = "ADMIN_INVALID_ROLE",
  ADMIN_CANT_DELETE_DEFAULT_ADMIN = "ADMIN_CANT_DELETE_DEFAULT_ADMIN",
  ORDER_SHIPMENT_NUMBER_EMPTY = "ORDER_SHIPMENT_NUMBER_EMPTY",
  ORDER_CANT_CHECK_GOPAY_STATE = "ORDER_CANT_CHECK_GOPAY_STATE",
  ADMIN_REGISTRATION_KEY_EMPTY = "ADMIN_REGISTRATION_KEY_EMPTY",
  ADMIN_REGISTRATION_KEY_INVALID = "ADMIN_REGISTRATION_KEY_INVALID",
  SUPPLEMENTARY_PRODUCT_PRODUCT_EMPTY = "SUPPLEMENTARY_PRODUCT_PRODUCT_EMPTY",
  SUPPLEMENTARY_PRODUCT_PRODUCT_ALREADY_EXISTS = "SUPPLEMENTARY_PRODUCT_PRODUCT_ALREADY_EXISTS",
}

export type TServerError = {
  key: ErrorKey;
  params?: {
    [key: string]: any;
  };
};

export type TServerErrorWithMultiParams = {
  key: ErrorKey;
  params: (
    | {
        [key: string]: any;
      }
    | undefined
  )[];
};

export type TServerErrorResponse = TServerError[];

export const isServerErrorResponse = (
  value: unknown
): value is TServerErrorResponse => {
  return Array.isArray(value) && value.every((error) => Boolean(error.key));
};

export const createServerErrorResponse = (error: any): TServerErrorResponse => {
  return (error as AxiosError<TServerErrorResponse>).response!.data;
};

export const serverErrorOfKey = (
  key: ErrorKey,
  serverErrors: TServerErrorResponse | undefined
): TServerError | undefined => {
  if (!serverErrors) {
    return;
  }

  return serverErrors.find((error) => error.key === key);
};

export const serverErrorsOfKey = (
  key: ErrorKey,
  serverErrors: TServerErrorResponse | undefined
): TServerError[] | undefined => {
  if (!serverErrors) {
    return;
  }

  const filteredErrors = serverErrors.filter((error) => error.key === key);

  return filteredErrors.length ? filteredErrors : undefined;
};

export const getUniqueServerErrors = (
  serverErrors: TServerError[]
): TServerErrorWithMultiParams[] => {
  const uniqueServerErrors: TServerErrorWithMultiParams[] = [];

  for (const serverError of serverErrors) {
    const existingIndex = uniqueServerErrors.findIndex(
      (s) => s.key === serverError.key
    );

    if (existingIndex === -1) {
      uniqueServerErrors.push({
        key: serverError.key,
        params: [serverError.params],
      });
    } else {
      uniqueServerErrors[existingIndex].params.push(serverError.params);
    }
  }

  return uniqueServerErrors;
};
